import { Link } from 'wouter';
import { email, phone } from '@/components/site-layout';
import { LegalPageLayout } from './legal-layout';

export default function TermsPage() {
  return (
    <LegalPageLayout
      title="Conditions générales de vente"
      description="Conditions applicables aux prestations de ménage et de repassage à domicile réalisées par SHER CLEAN."
    >
      <p>
        Prestations de ménage et de repassage à domicile — SHER CLEAN. Les
        présentes conditions s’appliquent aux prestations réalisées auprès de
        clients particuliers. Elles complètent le devis ou le contrat accepté.
      </p>

      <section>
        <h2>1. Identité du prestataire</h2>
        <p>
          SHER CLEAN est l’enseigne de SHER SOLUTIONS, exploitée par Semra Handan
          ER, entrepreneur individuel, domiciliée 6 rue du Commandant Pierre
          Mulsant, 10000 Troyes. SIREN : 952 088 607. SIRET : 952 088 607 00025.
          Déclaration Services à la personne / récépissé NOVA : SAP952088607.
          Contact : <a href={`mailto:${email}`}>{email}</a> —{' '}
          <a href="tel:+33628730551">{phone}</a>.
        </p>
      </section>

      <section>
        <h2>2. Prestations</h2>
        <p>
          SHER CLEAN propose des prestations de ménage et de repassage au
          domicile de particuliers. Le contenu de chaque prestation est décrit
          dans le devis accepté, le contrat régulier ou la fiche de liaison. Les
          demandes non prévues font l’objet d’un accord préalable.
        </p>
      </section>

      <section>
        <h2>3. Prix</h2>
        <p>
          Les tarifs applicables sont ceux indiqués sur le devis ou le contrat
          accepté. Pour l’offre de lancement du ménage régulier actuellement
          affichée sur le site, le tarif est de 28 € TTC par heure le premier
          mois, puis de 32 € TTC par heure à partir du deuxième mois. La durée
          minimale facturée est de 2 heures par passage.
        </p>
        <p>
          Les éventuels frais de déplacement ou frais spécifiques sont annoncés
          avant la réalisation de la prestation. Tant que le régime de franchise
          en base s’applique, les factures portent la mention « TVA non
          applicable, art. 293 B du CGI ». En cas de changement de régime de
          TVA, les documents tarifaires seront mis à jour avant application.
        </p>
      </section>

      <section>
        <h2>4. Devis et contrat</h2>
        <p>
          Le devis est gratuit. Pour une prestation ponctuelle, le devis accepté
          vaut contrat. Pour les prestations régulières, le contrat précise
          notamment la fréquence, le prix, la durée indicative des passages et
          les modalités pratiques.
        </p>
      </section>

      <section>
        <h2>5. Organisation des interventions</h2>
        <p>
          Les créneaux convenus sont indicatifs, sauf engagement écrit
          différent. Le client informe SHER CLEAN, dans la mesure du possible,
          au moins 24 heures calendaires avant le début prévu de l’intervention
          de toute demande de report ou d’annulation.
        </p>
        <p>
          En cas de demande reçue moins de 24 heures calendaires avant le début
          prévu de l’intervention, ou d’absence non signalée, une indemnité
          forfaitaire de désorganisation de 20 € pourra être facturée, sauf
          motif légitime ou force majeure signalé dès que possible. Les
          informations utiles à l’accès au domicile, à la sécurité, aux
          animaux, aux surfaces fragiles et au matériel sont portées à la
          connaissance de SHER CLEAN avant le passage.
        </p>
      </section>

      <section>
        <h2>6. Matériel et produits</h2>
        <p>
          Sauf accord contraire, le client met à disposition le matériel et les
          produits nécessaires. Le client signale les allergies, produits à
          éviter et surfaces nécessitant une précaution particulière. SHER CLEAN
          peut refuser d’utiliser un produit ou un matériel présentant un
          risque manifeste.
        </p>
      </section>

      <section>
        <h2>7. Facturation et règlement</h2>
        <p>
          Les prestations ponctuelles sont facturées après leur réalisation.
          Les prestations régulières sont facturées mensuellement, après les
          prestations du mois concerné. Le règlement s’effectue par prélèvement
          SEPA après signature du mandat joint au contrat, ou par Avance
          immédiate de l’Urssaf lorsque le service est effectivement activé,
          disponible et choisi par le client.
        </p>
        <p>
          La facture ou l’échéancier vaut notification préalable ; le délai de
          prévenance convenu est de 5 jours calendaires. Les CESU préfinancés
          seront acceptés uniquement après leur activation effective ; ils ne
          sont pas annoncés comme disponibles avant cette confirmation. En cas
          de difficulté de paiement, le client est invité à contacter rapidement
          SHER CLEAN afin de rechercher une solution amiable.
        </p>
      </section>

      <section>
        <h2>8. Crédit d’impôt et Avance immédiate</h2>
        <p>
          Les prestations de ménage et de repassage à domicile peuvent ouvrir
          droit à un crédit d’impôt de 50 %, sous réserve de l’éligibilité
          fiscale du client et des plafonds applicables. SHER CLEAN est déclarée
          Services à la personne sous le récépissé NOVA SAP952088607.
        </p>
        <p>
          Lorsque SHER CLEAN est habilitée à proposer l’Avance immédiate et que
          le client y est éligible, ce service est facultatif. Le client active
          son compte puis reçoit, après les prestations réalisées, une demande
          de paiement de l’Urssaf. Il dispose de 48 heures pour la valider ou la
          contester. SHER CLEAN reste l’interlocuteur du client pour toute
          question relative aux prestations ou à la facture.
        </p>
        <p>
          L’Avance immédiate est en cours de mise en place et ne sera présentée
          comme disponible qu’après son activation effective.
        </p>
      </section>

      <section>
        <h2>9. Droit de rétractation</h2>
        <p>
          Pour les contrats conclus à distance ou hors établissement, le client
          dispose, sauf exception légale, d’un délai de 14 jours à compter de la
          conclusion du contrat pour se rétracter sans donner de motif. Le
          formulaire type de rétractation est remis avec le devis ou le contrat.
          Lorsque le client demande le commencement d’une prestation avant la
          fin de ce délai dans les situations où cela est autorisé, il doit
          formuler une demande expresse. En cas de rétractation après le
          commencement, le client règle les prestations déjà réalisées, dans les
          conditions prévues par la loi.
        </p>
      </section>

      <section>
        <h2>10. Fin du contrat régulier</h2>
        <p>
          Le client peut mettre fin à un contrat régulier à tout moment, sans
          frais ni pénalité, par écrit. Les prestations déjà réalisées restent
          dues. SHER CLEAN peut également mettre fin au contrat avec un préavis
          raisonnable en cas de manquement répété, d’impossibilité de réaliser la
          prestation dans des conditions de sécurité satisfaisantes ou de
          non-paiement, après information écrite du client.
        </p>
      </section>

      <section>
        <h2>11. LITIGE – MÉDIATION DE LA CONSOMMATION</h2>
        <p>
          En cas de litige entre le Client et l’entreprise, ceux-ci s’efforceront
          de le résoudre à l’amiable (le Client adressera une réclamation écrite
          auprès du professionnel ou, le cas échéant, auprès du Service Relations
          Clientèle du professionnel).
        </p>
        <p>
          Pour adresser une réclamation écrite à SHER CLEAN :{' '}
          <a href={`mailto:${email}`}>{email}</a>.
        </p>
        <p>
          À défaut d’accord amiable ou en l’absence de réponse du professionnel
          dans un délai raisonnable d’un (1) mois, le Client consommateur au sens
          de l’article L.612-2 du code de la consommation a la possibilité de
          saisir gratuitement, si un désaccord subsiste, le médiateur compétent
          inscrit sur la liste des médiateurs établie par la Commission
          d’évaluation et de contrôle de la médiation de la consommation en
          application de l’article L.615-1 du code de la consommation, à savoir :
        </p>
        <p>
          La Société Médiation Professionnelle
          <br />
          <a
            href="https://www.mediateur-consommation-smp.fr"
            target="_blank"
            rel="noreferrer"
          >
            https://www.mediateur-consommation-smp.fr
          </a>
          <br />
          Alteritae — 5 rue Salvaing, 12000 Rodez
        </p>
      </section>

      <section>
        <h2>12. Données personnelles</h2>
        <p>
          Les données sont utilisées pour établir les devis, réaliser les
          prestations, assurer le suivi de la relation client et satisfaire aux
          obligations légales. Les modalités de traitement et les droits des
          personnes sont détaillés dans la{' '}
          <Link href="/confidentialite">politique de confidentialité</Link>.
        </p>
      </section>

      <section>
        <h2>13. Droit applicable</h2>
        <p>
          Les présentes conditions sont soumises au droit français. Elles ne
          privent pas le client consommateur des dispositions impératives qui
          lui sont applicables.
        </p>
      </section>

      <section>
        <h2>Acceptation</h2>
        <p>
          L’acceptation du devis ou la signature du contrat emporte acceptation
          des présentes Conditions générales de vente.
        </p>
      </section>
    </LegalPageLayout>
  );
}
